import { __ } from '@/plugins/i18n/'

export default [
  {
    path: '/login',
    component: () => import('@/layouts/l-login'),
    meta: {
      public: 'only',
    },
    children: [
      {
        path: '',
        name: 'Login',
        meta: {
          public: 'only',
        },
        component: () => import('@/views/v-login/index'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layouts/l-default/'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: {
          label: 'Buildings List',
        },
        component: () => import('@/views/v-buildings/'),
      },
      {
        path: '/apartments',
        name: 'Apartments',
        meta: {
          label: 'Apartments and tenants',
        },
        component: () => import('@/views/v-apartments/'),
      },
      {
        path: '/service-calls/:bid?',
        name: 'ServiceCalls',
        meta: {
          label: 'Service calls',
        },
        component: () => import('@/views/v-service-calls/'),
      },
      {
        path: '/service-call/:pid',
        name: 'OneServiceCall',
        meta: {
          label: 'Service calls',
        },
        component: () => import('@/views/v-service-calls/'),
      },
      {
        path: '/add-service-calls/:bid?',
        name: 'AddServiceCalls',
        meta: {
          label: 'New reading',
        },
        component: () => import('@/views/v-service-calls/add-service-call'),
      },
      {
        path: '/add-money/:bid?',
        name: 'AddMoney',
        meta: {
          label: 'Add Money',
        },
        component: () => import('@/views/v-service-calls/add-money'),
      },
      {
        path: '/suppliers/:supplierid?',
        name: 'Suppliers',
        meta: {
          label: 'Suppliers',
        },
        component: () => import('@/views/v-suppliers/'),
      },
      {
        path: '/building-suppliers/:bid',
        name: 'BuildingSuppliers',
        meta: {
          label: 'Suppliers',
        },
        component: () => import('@/views/v-building-suppliers/'),
      },
      {
        path: '/checksindex',
        name: 'Checks',
        meta: {
          label: 'Checks',
        },
        component: () =>
          import('@/views/v-financial-report/checks/ChecksIndex'),
      },
      {
        path: '/checks',
        name: 'ChecksPage',
        component: () => import('@/views/v-financial-report/checks/Checks'),
        meta: {
          label: 'Checks Group',
        },
      },
      {
        path: '/checks/checksfill/:checksGroupId',
        name: 'ChecksFill',
        component: () =>
          import('@/views/v-financial-report/checks/ChecksFillView'),
        meta: {
          label: 'Issuing Checks',
        },
      },
      {
        path: '/check-capture',
        name: 'CheckCapture',
        component: () =>
          import('@/views/v-financial-report/checks/CheckCapture'),
        meta: {
          label: 'Check Imaging',
        },
        props: (route) => ({
          captureUrl: route.query.captureUrl,
          checkGuid: route.query.checkGuid,
          checksGroupId: route.query.checksGroupId,
        }),
      },
      {
        path: '/maintenance-and-facilities',
        meta: {
          label: 'Maintenance and facilities',
        },
        component: () => import('@/views/v-maintenance-and-facilities/'),
        children: [
          {
            path: '',
            name: 'MaintenanceAndFacilities',
            meta: {
              label: 'Maintenance and facilities',
            },
            component: () =>
              import('@/views/v-maintenance-and-facilities/list'),
          },
          {
            path: ':id',
            name: 'MaintenanceAndFacilitiesDetail',
            meta: {
              label: 'Maintenance and facilities',
            },
            component: () =>
              import('@/views/v-maintenance-and-facilities/detail'),
          },
        ],
      },
      {
        name: 'DailyPlan',
        path: '/daily-plan',
        meta: {
          label: 'Daily Plan',
        },
        component: () => import('@/views/v-daily-plan'),
      },
      {
        name: 'FinancialReport',
        path: '/financial-report',
        meta: {
          label: __('Details of financial situation'),
        },
        component: () => import('@/views/v-financial-report/'),
        children: [
          {
            name: 'FinancialReport',
            path: ':contactId',
            meta: {
              label: __('Details of financial situation'),
            },
            component: () => import('@/views/v-financial-report/'),
          },
        ],
      },
      {
        name: 'UserProfile',
        path: '/user-profile',
        meta: {
          label: 'User profile',
        },
        component: () => import('@/views/v-user-profile/'),
      },
      {
        name: 'TenantRoom',
        path: '/tenant-room',
        meta: {
          label: "Tenants' room",
        },
        component: () => import('@/views/v-tenant-room/'),
      },
      {
        name: 'ApplicationFeedback',
        path: '/application-feedback',
        meta: {
          label: 'Application Feedback',
        },
        component: () => import('@/views/v-application-feedback'),
      },
      {
        name: 'Keys',
        path: '/keys',
        meta: {
          label: 'Keys List',
        },
        component: () => import('@/views/v-keys-and-mail-items'),
      },
      {
        name: 'AddKey',
        path: '/add-key',
        meta: {
          label: 'Save key',
        },
        component: () => import('@/views/v-keys-and-mail-items/add'),
      },
      {
        name: 'MailItems',
        path: '/mail-items',
        meta: {
          label: 'Mail items List',
        },
        component: () => import('@/views/v-keys-and-mail-items'),
      },
      {
        name: 'AddMailItem',
        path: '/add-mail-item',
        meta: {
          label: 'Save shipping',
        },
        component: () => import('@/views/v-keys-and-mail-items/add'),
      },
      {
        name: 'ElectricityMeter',
        path: '/electricity-meter/:bid',
        meta: {
          label: 'Electricity meter',
        },
        component: () => import('@/views/v-electricity-meter'),
      },
      {
        name: 'ConsumptionReport',
        path: '/consumption-report/:bid/:meterid',
        meta: {
          label: 'Consumption report',
        },
        component: () => import('@/views/v-electricity-meter/add-reading'),
      },
      {
        name: 'EditReport',
        path: '/consumption-report/:bid/:meterid',
        meta: {
          label: 'Consumption report',
        },
        component: () => import('@/views/v-electricity-meter/add-reading'),
      },
      {
        name: 'ReadingList',
        path: '/reading-report/:bid/:meterid',
        meta: {
          label: 'Reading report',
        },
        component: () => import('@/views/v-electricity-meter/reading-list'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: {
      public: true,
      label: __('Page not found'),
    },
    component: () => import('@/views/404'),
  },
]
